enum CookieKeys {
  p_authenticated = 'p-authenticated',
  cl = '_cl',
}

export default CookieKeys;
